import { useContext, useMemo } from 'react';
import toast from 'react-hot-toast';

import { ordersApi } from '../../../api';
import { ModalStateContext } from '../../../contexts/app-state-context/modal-state.context';
import { ConnectWalletModal } from '../../common/modal/connect-wallet';
import { OrderNotificationsModal } from '../../common/modal/OrderNotificationsModal.component';

export const useConnectWithNotifications = () => {
  const { setModal } = useContext(ModalStateContext);

  return useMemo(() => {
    const openNotificationsModal = async (
      walletAddress?: string,
      withEmptyNotification: boolean = false,
    ) => {
      if (walletAddress == null) {
        return;
      }

      const walletOrdersData = await ordersApi.receiveOrdersByOwner({
        ownerAddress: walletAddress,
        limit: 5,
      });

      const walletOrders = walletOrdersData?.data?.data as any[];

      if (walletOrders?.length > 0) {
        setModal(OrderNotificationsModal({ orders: walletOrders }));
      } else if (withEmptyNotification) {
        toast.error('No orders found');
      }
    };

    return {
      openConnectModal: () =>
        setModal(ConnectWalletModal(openNotificationsModal)),
      openNotificationsModal,
    };
  }, [setModal]);
};
